module.exports = __webpack_public_path__ + "img/completed-svg.651f8cc6.svg";